/* eslint-disable no-undef */

'use strict';

var scrollAnimate = require('./scrollAnimate');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append('<div class="email-signup-message"></div>');
    }
    $('.email-signup-message').append(
        '<div class="email-signup-alert text-center ' +
			status +
			'">' +
			data.msg +
			'</div>'
    );

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

// /**
//  * function used to change the date format as per service cloud
//  * @param {string} val - caelndar date
//  * @returns {string} formattedDate
//  */
// function changeDateFormat(val) {
//     const myArray = val.split('-');

//     let year = myArray[0];
//     let month = myArray[1];
//     let day = myArray[2];

//     let formatteddate = month + '/' + day + '/' + year;
//     return formatteddate;
// }

/**
 * Description
 * @param {string} name - name of the cookie
 * @param {string} value - value of the cookie
 * @param {string} seconds - time in seconds for the cookie to expire
 */
function createCookie(name, value, seconds) {
    var expires;
    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/;SameSite=Strict';
}

module.exports = function () {
    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    $('.subscribe-email').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('href');
        var button = $(this);
        var emailId = $('input[name=hpEmailSignUp]').val();
        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId,
            },
            success: function (data) {
                displayMessage(data, button);
            },
            error: function (err) {
                displayMessage(err, button);
            },
        });
    });

    $('body').on('click', '.footer-list-menu h6', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();

        if ($parent.hasClass('show')) {
            $parent.removeClass('show');
        } else {
            $parent.addClass('show');
        }
    });

    $('body').on('click', '.faq-section li .faq-question', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $parent = $this.parent();
        if ($parent.hasClass('active')) {
            $parent.removeClass('active');
            $parent.attr('aria-expanded', false);
        } else {
            $parent
                .addClass('active')
                .attr('aria-expanded', true)
                .siblings()
                .removeClass('active')
                .attr('aria-expanded', false);
        }
    });

    // eslint-disable-next-line consistent-return
    $('.signup-btn-mobile, .signup-btn').on('click', function (e) {
        e.preventDefault();
        $(this).attr('disabled', true);
        var email = $('#signup-email-newsletter').val();
        if (email === '') {
            $(this).attr('disabled', false);
            $('#signup-email-newsletter').css({ border: '1px solid red' });
            return false;
        }
        $.ajax({
            // eslint-disable-next-line no-template-curly-in-string
            url: $('#signup-email-newsletter').data('url'),
            type: 'post',
            data: { emailId: email },
            success: function () {
                window.localStorage.setItem('footersignup', 1);
                $('.js-footer-signup-form').submit();
            },
            error: function () {
                window.localStorage.setItem('footersignup', 1);
                $('.js-footer-signup-form').submit();
            },
        });
    });

    $(document).ready(function () {
        var footersignup = window.localStorage.getItem('footersignup');
        if (footersignup === '1') {
            window.localStorage.removeItem('footersignup');
            displayMessage(
                { success: true, msg: 'Thank you for your subscription.' },
                $('.signup-btn-mobile, .signup-btn')
            );
        }
    });

    $(document).ready(function () {
        var newsletterform = window.localStorage.getItem('newsletterform');
        if (newsletterform === '1') {
            window.localStorage.removeItem('newsletterform');
            displayMessage(
                { success: true, msg: 'Thank you for your subscription.' },
                $('.subscribe-newsletter')
            );
        }
    });

    $(document).ready(function () {
        if (typeof lhnJsSdk !== 'undefined') {
            lhnJsSdk.options = {
                hoc_button_tabindex: 0,
            };
        }
    });
    $('.banner-visit-us a').on('click', function (e) {
        if ($(this).text().trim().toLowerCase() === 'chat now') {
            e.preventDefault();
            if (lhnJsSdk !== undefined && lhnJsSdk && lhnJsSdk.openHOC) {
                lhnJsSdk.openHOC();
            }
        }
    });
    $('.experience-commerce_assets-button .assetBtn').on('click', function (e) {
        if ($(this).text().trim().toLowerCase() === 'speak to an expert') {
            e.preventDefault();
            if (lhnJsSdk !== undefined && lhnJsSdk && lhnJsSdk.openHOC) {
                lhnJsSdk.openHOC();
            }
        }
    });

    document.addEventListener('DOMContentLoaded', () => {
        const radioGroup = document.getElementById('radiogroup-container');
        if (radioGroup) {
            const radios = radioGroup.querySelectorAll('input[type="radio"]');

            radios.forEach((radio, index) => {
                radio.addEventListener('keydown', (e) => {
                    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                        e.preventDefault(); // Prevent scrolling

                        // Determine next or previous radio button
                        let newIndex = index;
                        if (e.key === 'ArrowDown') {
                            newIndex = (index + 1) % radios.length; // Move to next, loop back to first
                        } else if (e.key === 'ArrowUp') {
                            newIndex = (index - 1 + radios.length) % radios.length; // Move to previous, loop to last
                        }

                        // Set focus and check the new radio button
                        radios[newIndex].focus();
                    }
                });
            });
        }
    });

    $('.js-chat-card').on('click', function (e) {
        e.preventDefault();
        if (lhnJsSdk !== undefined && lhnJsSdk && lhnJsSdk.openHOC) {
            lhnJsSdk.openHOC();
        }
    });

    $('.form-check-input').on('click', function () {
        let group = $(this).data('group');
        $(`.form-check-input[data-group="${group}"]`)
            .not(this)
            .prop('checked', false);
    });
    $(document).ready(function () {
        const urlParams = new URLSearchParams(window.location.search);
        const value = urlParams.get('rep');
        if (value !== null) {
            createCookie('repCode', value, 86400);
        }
    });
};
